module.exports = __webpack_public_path__ + "img/lesotho.c1ba466b.png";